<template>
    <v-container class="questionnaire custom-bg">
        <v-row>
            <v-col class="question-col"  cols="12">
                <!-- Title -->
                <h1>{{ title }}</h1>                
                <v-btn color="red" v-if="isDevelopment" @click="prepopulate()">
                    Prepopulate Likert
                </v-btn>
            </v-col>
        </v-row>

        <v-row>
            <v-col class="question-col" cols="12">
                <!-- Instructions -->
                 <v-card>
                    <v-card-text>
                        <div v-html="instructions"/>                
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>        

        <v-row v-for="(question, qIndex) in questions">
            <v-col class="question-col"  cols="12" >                
                <component            
                    :key="question.id"
                    :is="`${question.type}Component`"
                    v-model="questions[qIndex]"
                    @update:modelValue="questions[qIndex] = $event"
                />
            </v-col>
        </v-row>
        
        <!-- <v-row>
            <v-col cols="12">
                <v-btn color="primary" @click="submit">Submit</v-btn>
            </v-col>
        </v-row>         -->
        <!-- <button type="button" bg-color="white" @click="submit">Submit</button> -->        
    </v-container>
</template>

<script>
import TextFieldComponent from './TextFieldComponent.vue';
import TextAreaComponent from './TextAreaComponent.vue';
import CheckboxComponent from './CheckboxComponent.vue';
import SelectComponent from './SelectComponent.vue';
import RadioGroupComponent from './RadioGroupComponent.vue';
import LikertComponent from './LikertComponent.vue';
import CheckboxesComponent from './CheckboxesComponent.vue';
import MultipleChoiceGridComponent from './MultipleChoiceGridComponent.vue';
import CheckboxGridComponent from './CheckboxGridComponent.vue';
import { emptyMatrix } from '../../utils/matrix.js';
import envMixin from '@/mixins/envMixin'

export default {
    name: "ScaleComponent",
    mixins: [envMixin],
    components: {
        TextFieldComponent,
        TextAreaComponent,
        CheckboxComponent,
        SelectComponent,
        RadioGroupComponent,
        LikertComponent,
        CheckboxesComponent,
        MultipleChoiceGridComponent,
        CheckboxGridComponent,
    },

    props: {
        rawData: {
            type: Object,
            required: true
        },        
    },

    emits: ['questionnaire-submited'],

    data() {
        return {
            ...this.rawData,
            // allowPrepopulate: true,
        }
    },    

    created() {
        // Initialize the `value` field for each question
        this.questions.forEach((question, idx) => {

            if (question.type === "MultipleChoiceGrid" || question.type === "CheckboxGrid") {
                question.value = emptyMatrix(question.rows.length, question.columns.length, false); // Default to an empty matrix  
            } 
            question.index = idx
        });
    },

    methods:{
        prepopulate(){
            this.questions.forEach((question, idx) => {
                if (question.type === "Likert") {
                    question.value = idx % 3 + 1;
                }
            });
        },

        collect(){
            // Collect all field values
            const collectedValues = [];
            this.questions.forEach((question, idx) => {
                if (question.type === "fieldset") {
                    // Handle nested controls in fieldsets                    
                    let inner_values = question.controls.map((control, idx) => control.value);
                    collectedValues.push(inner_values); //Store it as 1-indexed
                } else {
                    // collectedValues[question.name] = question.value;
                    collectedValues.push(question.value); //Store it as 1-indexed
                }
            });            
            return collectedValues;
        },

        validate() {            

            // Perform validation logic (example: check if all required fields are filled)
            let isValid = true;

            this.questions.map((question) => {
                console.log("Validating question type:", question.type);
                console.log("Validating question value:", question.value);
                if (question.type === "TextField" || question.type === "TextArea") {
                    // console.log(`Validating question=[${question.title}], value=${question.value} mandatory=${question.mandatory}`, question);
                    if( (!question.value || question.value.trim() === "") && question.mandatory ) {
                        question.error = this.$t('scaleComponent.this_field_is_required');
                        isValid = false; // Invalid if mandatory field is empty
                    } else {
                        question.error = ""; // Clear error if valid
                    }
                }
                if (question.type === "Select") {
                    if(question.mandatory && question.value === undefined){
                        question.error = this.$t('scaleComponent.this_field_is_required');
                        isValid = false; // Invalid if mandatory select is not selected
                    } else {
                        question.error = ""; // Clear error if valid
                    }
                    // return question.value !== null; // Ensure a selection is made
                }
                if (question.type === "RadioGroup") {
                    isValid &&= question.value !== null; // Ensure a radio option is selected
                }
                if (question.type === "Checkbox") {
                    if (question.mandatory && question.value === undefined){
                        question.error = this.$t('scaleComponent.this_field_is_required');
                        isValid = false; // Invalid if mandatory checkbox is not checked
                    } else {
                        question.error = ""; // Clear error if valid
                    }
                    // return typeof question.value === "boolean"; // Ensure checkbox has a boolean value
                }
                if (question.type === "Likert") {
                    if (/*question.mandatory && */ question.value === undefined){ // Made Likert mandatory
                        question.error = this.$t('scaleComponent.this_field_is_required');
                        isValid = false; // Invalid if mandatory checkbox is not checked
                    } else {
                        question.error = ""; // Clear error if valid
                    }
                }
            });

            return isValid;
        },

        submit(){
            let valid = this.validate();
            alert(`QuestionnaireComponent > submit > Submit pressed. Valid: ${valid}`);

            let collectedValues = this.collect();
            alert(`QuestionnaireComponent > submit > collectedValues: ${collectedValues}`);
            this.$emit('questionnaire-submited', collectedValues);

        }
    }
}
</script>

<style scoped>
.question-col {
  padding-bottom: 4px !important;
  padding-top: 4px !important;
}

.questionnaire {
    /* max-width: 800px; */
    margin: auto;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}   

.custom-bg {
  background-color: rgb(var(--v-theme-surface-variant), 0.1);
}
</style>